<template>
  <div class="address-list-wrapper">
    <div class="list-loading" v-if="!dataDone"><van-loading type="spinner" size="14px">正在加载中...</van-loading></div>
    <div class="address-list" v-else-if="dataDone && addressList.length > 0">
      <div class="address-item" v-for="item in addressList">
        <div class="item-header">
          <div class="user-info">{{item.name}}<span>{{item.mobile}}</span></div>
          <div class="edit" @click="editAddress(item.address_id)">编辑</div>
        </div>
        <div class="item-content">{{item.province + item.city + item.country + item.region}}</div>
      </div>
    </div>
    <div class="empty-address" v-else-if="dataDone && addressList.length <= 0">
      <icon icon-class="address-empty"></icon>
      <p>暂无收货地址</p>
    </div>
    <div class="new-address" v-if="dataDone"><button class="add-button" @click="editAddress(null)">新增收货地址</button></div>
  </div>
</template>

<style lang="less" scoped>
  .address-list-wrapper{
    position: relative;
    min-height: 100vh;
    background: #FAFAFA;
    .empty-address{
      padding-top: 220px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #CCC;
      text-align: center;
      flex-direction: column;
      svg{
        font-size: 72px;
      }
      p{
        margin-top: 12px;
        font-size: 15px;
        line-height: 15px;
      }
    }
    .address-list{
      padding: 12px 16px 64px;
      .address-item{
        margin-bottom: 12px;
        background: #FFF;
        box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
        border-radius: 4px;
        .item-header{
          height: 48px;
          padding: 0 0 0 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #FAFAFA;
          border-bottom: 1px solid #F3F3F3;
          .user-info{
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            line-height: 16px;
            padding-left: 19px;
            font-size: 16px;
            color: @black;
            font-weight: bold;
            span{
              margin-left: 15px;
            }
            &::after{
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              height: 16px;
              width: 4px;
              border-radius: 2px;
              background: @xile;
            }
          }
          .edit{
            height: 100%;
            padding: 0 20px;
            font-size: 14px;
            line-height: 14px;
            color: #666;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .item-content{
          padding: 20px;
          font-size: 14px;
          line-height: 24px;
          color: #666;
        }
      }
    }
    .new-address{
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 12px 16px;
      background: #FAFAFA;
      .add-button{
        @button-base();
        width: 100%;
        height: 40px;
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        addressList: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
    console.log('地址列表')
      this.$root.post('/getAddressList', {
        user_id: this.userInfo.user_id
      }).then(data => {
        console.log(data)
        this.dataDone = true;
        this.addressList = data || [];
      })
    },
    methods: {
      editAddress(id) {
        if(!id) {
          this.$router.push('/patient/address/edit');
        }else {
          this.$router.push({path: '/patient/address/edit', query: {address_id: id}});
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Address/list.vue